import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo lo recibo después de comprar?',
    a: 'Acceso inmediato. Te llega el link/archivo PDF al email del pago (y/o pantalla de descarga).'
  }, {
    q: '¿Sirve si soy nutri recién recibido/a?',
    a: 'Sí: te da estructura, guiones y criterio para no trabarte en consulta.'
  }, {
    q: '¿Sirve si ya tengo experiencia?',
    a: 'Sí: está pensado para ganar velocidad, orden y consistencia sin bajar calidad.'
  }, {
    q: '¿Es para Argentina?',
    a: 'Sí: está hecho para el contexto real del nutri en Argentina y se paga por Mercado Pago.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí: 7 días, devolución total.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 px-4 max-w-3xl mx-auto" data-id="element-34">
      <FadeIn data-id="element-35">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint text-center mb-8" data-id="element-36">
          PREGUNTAS FRECUENTES
        </h2>
      </FadeIn>

      <div className="space-y-4" data-id="element-37">
        {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-38">
            <div className="bg-surface rounded-xl border border-mint/10 overflow-hidden" data-id="element-39">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full text-left px-6 py-4 flex items-center justify-between font-bold text-mint hover:bg-mint/5 transition-colors" data-id="element-40">
                <span className="pr-4" data-id="element-41">{faq.q}</span>
                <ChevronDown className={`shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={20} data-id="element-42" />
              </button>
              <AnimatePresence data-id="element-43">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                    <div className="px-6 pb-4 text-white/70" data-id="element-45">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}